import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ProfileContainer } from "../../components/ProfileContainer/ProfileContainer";

const UserProfileScreen = () => {
  return (
    <ScreenLayout>
      <ProfileContainer />
    </ScreenLayout>
  );
};

export default UserProfileScreen;
